//#region redux
import { useDispatch } from "react-redux";
//#endregion
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { supplementaryMaterialSnoozed } from "store/actions/supplementaryMaterialActions";
//#endregion
import useSnoozeAction from "components/common/useSnoozeAction";

function useSupplementaryMaterialSnoozeAction(id: number, markAsDone: (id: number) => void) {
  const dispatch = useDispatch();

  const onSnoozeSuccess = () => {
    dispatch(supplementaryMaterialSnoozed(id));
    markAsDone(id);
  };

  const { snoozeAction } = useSnoozeAction(id, WintSuperkollAPIModel.TodoType.SupplementaryMaterial, onSnoozeSuccess);

  return snoozeAction;
}

export default useSupplementaryMaterialSnoozeAction;
